import { track } from "@amplitude/analytics-react-native";
import { StyleProp, ViewStyle } from "react-native";
import ModerationEvaluation from "src/api/graphql/__generated__/enums/ModerationEvaluation";
import PhotoState from "src/api/graphql/__generated__/enums/PhotoState";
import { SelectedPhoto, useGatheringStore } from "src/contexts/GatheringContext";
import pluralS from "src/helpers/pluralS";
import useSetGatheringPhotoModeration from "src/hooks/useSetGatheringPhotoModeration";
import useStyle from "src/hooks/useStyle";
import IconHide from "src/icons/IconHide";
import IconUnhide from "src/icons/IconUnhide";
import { color } from "src/styles";
import { alert } from "src/swsh-native";
import FloatingActionItem from "./FloatingActionItem";

const FloatingHideButton = ({
	containerStyle,
	selectedPhotos,
}: {
	containerStyle?: StyleProp<ViewStyle>;
	selectedPhotos: SelectedPhoto[];
}) => {
	const { theme } = useStyle();
	const gatheringId = useGatheringStore((state) => state.gatheringId);
	const resetSelectMode = useGatheringStore((state) => state.resetSelectMode);

	const { loading, setGatheringPhotoModeration } = useSetGatheringPhotoModeration();

	if (selectedPhotos.every((photo) => photo.state === PhotoState.Hidden)) {
		return (
			<FloatingActionItem
				Icon={IconUnhide}
				loading={loading}
				containerStyle={containerStyle}
				color={color.Text[theme]}
				testID="Select-Unhide"
				onPress={async () => {
					alert({
						title: `Are you sure you want to unhide ${selectedPhotos.length} item${pluralS(selectedPhotos.length)}?`,
						message: "This will make the content visible to album participants.",
						buttons: [
							{
								text: "Cancel",
								style: "cancel",
							},
							{
								text: "Unhide",
								style: "default",
								onPress: async () => {
									track("FloatingHide-Unhide", {
										numPhotos: selectedPhotos.length,
									});
									await setGatheringPhotoModeration({
										gatheringId,
										photoIds: selectedPhotos.map((photo) => photo.photoId),
										moderation: ModerationEvaluation.ManualAllow,
									});
									resetSelectMode();
								},
							},
						],
					});
				}}
			/>
		);
	} else {
		return (
			<FloatingActionItem
				Icon={IconHide}
				loading={loading}
				containerStyle={containerStyle}
				color={color.Text[theme]}
				testID="Select-Hide"
				onPress={async () => {
					alert({
						title: `Are you sure you want to hide ${selectedPhotos.length} item${pluralS(selectedPhotos.length)}?`,
						message: "This will hide the content from album participants.",
						buttons: [
							{
								text: "Cancel",
								style: "cancel",
							},
							{
								text: "Hide",
								style: "default",
								onPress: async () => {
									track("FloatingHide-Hide", {
										numPhotos: selectedPhotos.length,
									});
									await setGatheringPhotoModeration({
										gatheringId,
										photoIds: selectedPhotos.map((photo) => photo.photoId),
										moderation: ModerationEvaluation.ManualBlock,
									});
									resetSelectMode();
								},
							},
						],
					});
				}}
			/>
		);
	}
};
export default FloatingHideButton;
